<template>
  <v-alert :type="type" v-if="visible" :color="color" dark :width="width">
    <template v-slot:close>
      <v-icon @click="clickClose"> mdi-close </v-icon>
    </template>
    {{ message }}
  </v-alert>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "",
    },
    clickClose: {
      type: Function,
    },
    visible: Boolean,
    message: [String, Boolean],
    color: {
      type: String,
      default: "",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "100%",
    },
  },
};
</script>
